import React from 'react';

const Input = ({label, tipo, value, onChange}) => {

    const handleChange = (e) => {
        onChange(e.target.value); // Llama a la función onChange pasándole el nuevo valor del input
    };

    return (
        <React.Fragment>
            <div>
                <label className='font-semibold'>{label}</label>
                <input className='w-full text-sm px-4 py-3 my-2 md:mr-3 bg-white rounded-lg border border-solid border-gray-400 b-1 focus:outline-none focus:ring focus:ring-customRed focus:ring-opacity-30' 
                    type={tipo} 
                    placeholder={label} 
                    value={value} 
                    onChange={handleChange}
                    required
                />
            </div>
        </React.Fragment>
    );
}

export default Input;